// @flow strict

import React from 'react';
import PropTypes from 'prop-types';
import { useLanguageContext } from '~contexts/language-context';

import * as styles from './menuItem.module.less';

export const MenuItem = ({ data }) => {
  const { loc, language } = useLanguageContext();

  return (
    <a href={data.href} className={styles.menuTitle}>
      <p className={styles.titleName}>
        {data.name}
        {data.badge && <span className={styles.badge}>{data.badge}</span>}
      </p>
      <p>{data.text}</p>
    </a>
  );
};

MenuItem.propTypes = {
  data: PropTypes.object,
};
